import * as React from 'react';
import { LoadOptions } from 'app/types-shared';
import { codePickersId, CodeCodetablePickerProps } from './types';
import { CodeFieldWireKey } from 'app/area/indicator-factors/types-store';
import { SinglePickerCreator } from 'app/area/indicator-factors/common/single-picker-creator';
import { getDisabledValidation } from 'app/area/shared/codetable/item/codetable-item-helpers';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const Substance = (props: CodeCodetablePickerProps) => {

  const { breadcrumbs, codeItem, codetableOptions, loadCodetableOptions, translation, validation, readOnly } = props;

  const codetableId = codePickersId.substance;
  const codetableKey = CodeFieldWireKey.substance;

  const substanceCategoryId = codePickersId.substanceCategory;
  const substanceCategoryKey = CodeFieldWireKey.substanceCategory;
  const substanceUomKey = CodeFieldWireKey.substanceUom;

  const substanceCategoryValue = codeItem?.[substanceCategoryKey]?.value ?? codeItem?.[codetableKey]?.category?.value
    ?? codeItem?.[codetableKey]?.categoryId;

  const limitFieldsTo = [CodeFieldWireKey.code, CodeFieldWireKey.defaultUomType, CodeFieldWireKey.category];

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) =>
    loadCodetableOptions(id, codetableId, loadOptionsParams, { limitFieldsTo });

  const onLoadCategoryOptions = (loadOptionsParams: LoadOptions) => {
    loadCodetableOptions(substanceCategoryKey, substanceCategoryId, loadOptionsParams, { limitFieldsTo });
  };

  const categoryOptions = codetableOptions?.[substanceCategoryKey]?.codes ?? [];

  const currentValidation = validation?.[codetableKey];

  const finalValidation = {
    ...currentValidation,
    ...getDisabledValidation(codeItem?.[codetableKey]?.disabled, translation.selected_value_disabled),
    ...getDisabledValidation(codeItem?.[substanceCategoryKey]?.disabled, translation.selected_value_disabled)
  };

  const onChange = (value: CodeComplexValue<number>) => {
    props.resetValidation(codetableKey, value);
    props.resetValidation(substanceUomKey, undefined);
    props.onChange(codetableKey, value);
    props.onChange(substanceCategoryKey, isDefinedIncludingZero(value?.category?.value) ? value.category : { value: value?.categoryId });
    props.onChange(substanceUomKey, undefined);
    props.clearAllValidation(codetableKey);
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, codetableId, breadcrumbs);

  const valueItem: CodeComplexValue<number> = {
    ...codeItem?.[codetableKey],
    categoryId: substanceCategoryValue
  };

  return <SinglePickerCreator
    id={codetableKey}
    label={translation.substance}
    valueItem={valueItem}
    searchRequired={false}
    required={!readOnly}
    readOnly={readOnly}
    options={codetableOptions?.[codetableKey]?.codes}
    fetchingOptions={codetableOptions?.[codetableKey]?.fetching || codetableOptions?.[substanceCategoryKey]?.fetching}
    translation={translation}
    onLoadOptions={onLoadOptions}
    onChange={onChange}
    extraFooterButton={extraFooterButton}
    validation={finalValidation}
    displayCategories={true}
    onLoadCategoryOptions={onLoadCategoryOptions}
    categoryOptions={categoryOptions}
    categoryId={substanceCategoryValue}
  />;
};
